<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <h3 class="my-4">{{'lang.companyEdit.companyDetails' | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name" sbAutofocus>
                    <span class="form-text text-muted">{{'lang.globals.nameDescription' | translate}}</span>
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">{{'lang.globals.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="UniqueIdentifier">{{'lang.globals.uniqueIdentifier' | translate}}</label>
                    <input type="text" id="UniqueIdentifier" class="form-control" formControlName="UniqueIdentifier">
                    <span class="form-text text-muted">{{'lang.globals.uniqueIdentifierDescription' | translate}}</span>
                    <div *ngIf="UniqueIdentifier.touched && UniqueIdentifier.errors?.required"
                         class="alert alert-danger">{{'lang.globals.uniqueIdentifierWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <hr class="border-dashed">
              <sb-comp-address-component
                *ngIf="!loading && company?.address"
                [point]="point" [address]="company?.address"
                (pointEmitter)="point = $event"
                (addressEmitter)="addressUpdate($event)">
              </sb-comp-address-component>
              <div class="wizard__footerActions">
                <sb-button (click)="util.returnToNavigation(util.RoutingID.companies)"
                           classes="btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}</sb-button>
                <button (click)="updateCompany()"
                           [disabled]="!form.valid || !company.address.country || (!(company.address?.position?.coordinates[0]) !== !(company.address?.position?.coordinates[1])) || loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
          <div style="background-color: #f3f6f9;"
               class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column"
               *ngIf="!isInIntegratedContext">
            <div *ngIf="wizardState!=='Map'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon icon="cancel" class="icon-in-btn mr-1"></sb-icon>
                {{'lang.globals.closeFilterSelection' | translate}}
              </button>
            </div>

            <div *ngIf="wizardState==='Map' ">
              <sb-map
                [drawing]="false"
                [mapHeight]="934"
                [showSinglePoint]="point"
                (singlePointSelected)="point = $event"
                [selectSinglePoint]="true"
                [whatIsHere]="true"
              >
              </sb-map>
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
